// Remove ignored Office declarations and document metadata, not visual classes or wrappers.
export function cleanOfficePaste(html: string): string {
    if (!/(?:\bmso-|class\s*=\s*["'][^"']*\bMso|urn:schemas-microsoft-com:office|<\/?(?:o|w|v):|\[if[^\]]*(?:mso|supportLists|supportLineBreakNewLine))/i.test(html)) return html;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const comments = doc.createTreeWalker(doc, NodeFilter.SHOW_COMMENT);
    const removableComments: Node[] = [];
    while (comments.nextNode()) {
        if (/<(?:w:WordDocument|o:DocumentProperties|o:CustomDocumentProperties)\b/i.test(comments.currentNode.nodeValue ?? '')) {
            removableComments.push(comments.currentNode);
        }
    }
    removableComments.forEach(comment => comment.parentNode?.removeChild(comment));

    doc.querySelectorAll('*').forEach(element => {
        if (element.tagName.toLowerCase() === 'xml' &&
            element.querySelector('w\\:WordDocument, o\\:DocumentProperties, o\\:CustomDocumentProperties')) {
            element.remove();
            return;
        }
        const style = element.getAttribute('style');
        if (style) {
            const cleaned = splitDeclarations(style).filter(declaration => !/^\s*mso-/i.test(declaration)).join(';');
            if (cleaned.trim()) element.setAttribute('style', cleaned);
            else element.removeAttribute('style');
        }
    });
    // Keep stylesheet definitions: Office class names can reference standard CSS.
    return Array.from(doc.head.querySelectorAll('style, link[rel="stylesheet"]')).map(element => element.outerHTML).join('') + doc.body.innerHTML;
}

function splitDeclarations(style: string): string[] {
    const declarations: string[] = [];
    let start = 0;
    let quote = '';
    let depth = 0;
    for (let index = 0; index < style.length; index++) {
        const char = style[index];
        if (char === '\\') { index++; continue; }
        if (quote) { if (char === quote) quote = ''; }
        else if (char === '"' || char === "'") quote = char;
        else if (char === '(') depth++;
        else if (char === ')') depth--;
        else if (char === ';' && depth === 0) {
            declarations.push(style.slice(start, index));
            start = index + 1;
        }
    }
    declarations.push(style.slice(start));
    return declarations;
}
